import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { translate } from '../../core/i18n';
import { getComponentData, setComponentData } from '../../core/views';
import { QUESTION_MODAL_STATE } from '../../core/constants';
import { store } from '../../core/state';
import { BaseModal } from './BaseModal';

export interface QuestionModalOpts {
  okTitle? : string,
  okColor? : string,
  okIcon? : string,
  cancelTitle? : string,
  cancelColor? : string,
  secondBtnText? : string,
  secondColor? : string,
  secondIcon? : string,
  large? : boolean,
  closeWindowLink? : boolean,
  titlesAsDetail?: boolean
}

export const showQuestionModal = (title : string, children : string, okClicked : () => void, cancelClicked? : () => void, opts? : QuestionModalOpts, secondBtnClick? : () => void) : void => {
  const modalState = getComponentData(QUESTION_MODAL_STATE);
  modalState.data = {
    show : true,
    title,
    children,
    okClicked,
    cancelClicked,
    opts,
    secondBtnClick,    
  };
  setComponentData(QUESTION_MODAL_STATE, modalState);
}

export const hideModal = () : void => {
  setComponentData(QUESTION_MODAL_STATE, { data : { show : false }});
}

export const QuestionModal = () => {
  const [modalState, setModalState] = store.useState(QUESTION_MODAL_STATE);

  if (!modalState?.data) {
    setModalState({ data : { show : false }});
    return null;
  }

  const okRequested = () : void => {
    removeModal();
    if (modalState.data?.okClicked) {
      modalState.data?.okClicked();
    }
  }

  const abortRequested = () : void => {
    removeModal();
    if (modalState.data?.cancelClicked) {
      modalState.data?.cancelClicked();
    }
  }

  const secondBtnRequested = () : void => {
    removeModal();
    if (modalState.data?.secondBtnClick) {
      modalState.data?.secondBtnClick();
    }
  }

  const removeModal = () => {
    setModalState({ data : { show : false }});
  }

  //console.log("render question with data:", modalState.data);
  const noText = modalState.data.opts?.titlesAsDetail ? translate("modal-no") : translate("modal-cancel");
  const cancelText = modalState.data.opts?.cancelTitle && !modalState.data.opts?.titlesAsDetail ? modalState.data.opts?.cancelTitle : noText;
  let cancelColor = modalState.data.opts?.cancelColor ? 'btn ' + modalState.data.opts?.cancelColor : "btn btn-danger";
  if (modalState.data.opts?.large) {
    cancelColor += " btn-lg";
  }
  if (modalState.data.opts?.titlesAsDetail) {
    cancelColor += " full-width";
  }

  const cancelButton = (<button type="button" className={cancelColor} data-dismiss="modal" onClick={abortRequested}>
      <FontAwesomeIcon icon="times" />&nbsp; {cancelText}
    </button>);
  const cancel = modalState.data.cancelClicked && cancelButton;

  const yesText = modalState.data.opts?.titlesAsDetail ? translate("modal-yes") : translate("modal-ok");
  const okText = modalState.data.opts?.okTitle && !modalState.data.opts?.titlesAsDetail ? modalState.data.opts?.okTitle : yesText;
  const okIcon = modalState.data.opts?.okIcon ? modalState.data.opts?.okIcon : "check";
  let okColor = modalState.data.opts?.okColor ? 'btn ' + modalState.data.opts?.okColor : "btn btn-success";
  if (modalState.data.opts?.large) {
    okColor += " btn-lg";
  }
  if (modalState.data.opts?.titlesAsDetail) {
    okColor += " full-width";
  }
  const okButton = <button id="modal-success" type="button" className={okColor} onClick={okRequested}>
    <FontAwesomeIcon icon={okIcon} />&nbsp; {okText}
  </button>;

  let secondBtn = null;
  if (modalState.data.secondBtnClick !== undefined) {
    const secondBtnText = modalState.data.opts?.secondBtnText ? modalState.data.opts?.secondBtnText : translate("modal-no");
    let secondColor = modalState.data.opts?.secondColor ? 'btn ' + modalState.data.opts?.secondColor : "btn btn-warning";
    const secondIcon = modalState.data.opts?.secondIcon ? modalState.data.opts?.secondIcon : "exclamation";
    if (modalState.data.opts?.large) {
      secondColor += " btn-lg";
    }
    secondBtn = (<button type="button" className={secondColor} data-dismiss="modal" onClick={secondBtnRequested}>
      <FontAwesomeIcon icon={secondIcon} />&nbsp; {secondBtnText}
    </button>);
  }

  const footer = modalState.data.opts?.titlesAsDetail ? (
    <div className="row w-100">
      <div className="col-6 d-flex flex-column align-items-center">
        {okButton}
        <p onClick={okRequested}>{modalState.data.opts?.okTitle}</p>
      </div>
      <div className="col-6 d-flex flex-column align-items-center">
        {cancelButton}
        <p onClick={abortRequested}>{modalState.data.opts?.cancelTitle}</p>
      </div>
    </div>
  ) : (
    <>
      {secondBtn}
      {okButton}
      {cancel}
    </>
  );

  //size only lg if large is set
  const size = modalState.data.opts?.large ? "lg" : undefined;

  return (
    <BaseModal title={modalState.data.title}
               bodyHtml={modalState.data.children}
               footer={footer}
               size={size}
               show= {modalState.data.show}
               handleClose={abortRequested}
               footerCentered={modalState.data.opts?.titlesAsDetail}
               closingDisabled={modalState.data.opts?.closingDisabled}
                />
  );
};
